import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { RemoveWebPhoto, RemoveWebPhotoVariables } from '../../../athena/types/RemoveWebPhoto';

export const MUTATION = gql`
  mutation RemoveWebPhoto($maintenanceRequestId: String!, $fileName: String!, $kind: String!) {
    webMaintenance {
      removeWebPhoto(
        input: { picableId: $maintenanceRequestId, originalFilename: $fileName, kind: $kind }
      ) {
        _empty
      }
    }
  }
`;

const useRemoveWebPhoto = () => useMutation<RemoveWebPhoto, RemoveWebPhotoVariables>(MUTATION);

export default useRemoveWebPhoto;
